import { firestore, db } from "../firebase";

const classDB = db.collection("classes");

/**
 * @param {string} docId
 */
export async function idExisits(docId) {
  const ref = classDB.doc(docId);
  return (await ref.get()).exists;
}

/**
 * @param {string} uid
 */
export async function hasClass(uid) {
  const query = classDB.where("uid", "==", uid);
  const count = await query.get();
  return count.size == 0 ? false : true;
}

/**
 * @param {string} code
 * @param {string} uid
 */
export async function add(code, uid) {
  return classDB.doc(code).set({
    uid,
  });
}

export async function getTeacherClass(uid) {
  const query = await db.collection("classes").where("uid", "==", uid).get();
  return query.docs[0];
}
